import styled from "styled-components";

export const LandingContainer = styled.section`
  width: 100%;
  /* background: var(--bg-color); */
  height: auto;
`;

export const MainContainer = styled.main`
  width: 100%;
`;
export const TextContainer = styled.div`
  width: ${(props) => props.width};
  height: ${(props) => props.height};

  p {
    font-size: 1.6rem;
    font-weight: 400;
    line-height: 3.2rem;
    font-family: Peyda;
    color: var(--title-color);
    @media (max-width: 768px) {
      font-size: 1.4rem;
      line-height: 2rem;
    }
  }
  @media (max-width: 600px) {
    margin-top: 2rem;
  }
  @media (max-width: 400px) {
    width: ${(props) => props.width400};
  }
  @media (max-width: 1350px) {
    width: 100%;
  }
  @media (max-width: 525px) {
    font-size: 1.6rem;
  }
`;
export const TitleContainer = styled.div`
  width: ${(props) => props.width};
  position: relative;
  margin-top: 4rem;
  span {
    display: inline-block;
    width: 11.11px;
    height: 21px;
    position: absolute;
    top: 52px;
    left: 98%;
    background-color: ${(props) => props.color || "#fff"};
  }
  h5 {
    font-size: 1.6rem;
    font-weight: 800;
    color: var(--span-color);
    opacity: ${(props) => props.opacity || "1"};
    margin-bottom: 1.3rem;
    font-family: Peyda;
  }
  /* p {
    font-size: 3.2rem;
    font-weight: 700;
    line-height: 5.3rem;
    padding-right: 1.4rem;
    color: ${(props) => props.textColor || "#FFFFFF"};
  } */
  @media (max-width: 1200px) {
    h5 {
      font-size: 1.4rem;
    }
    p {
      font-size: 2.9rem;
    }
  }
  @media (max-width: 1000px) {
    h5 {
      font-size: 1.2rem;
    }
    p {
      font-size: 2.5rem;
    }
  }

  @media (max-width: 800px) {
    h5 {
      font-size: 1rem;
    }
    p {
      font-size: 2.2rem;
    }
  }
  @media (max-width: 600px) {
    width: 100%;
  }
  @media (max-width: 525px) {
    p {
      font-size: 2rem;
    }
  }
`;

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1435px;
  @media (max-width: 1470px) {
    object-fit: cover;
    max-width: 1200px;
  }
  @media (max-width: 1300px) {
    max-width: 1070px;
  }
  @media (max-width: 1150px) {
    max-width: 970px;
  }
  @media (max-width: 1024px) {
    max-width: 800px;
  }
  @media (max-width: 850px) {
    max-width: 700px;
  }
  @media (max-width: 740px) {
    max-width: 650px;
  }
  @media (max-width: 680px) {
    max-width: 580px;
  }
  @media (max-width: 600px) {
    max-width: 536px;
  }
  @media (max-width: 580px) {
    max-width: 430px;
  }
  @media (max-width: 480px) {
    max-width: 328px;
  }
`;
